var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createBreakpoints } from "./createBreakpoints";
import { createOverrides } from "./createOverrides";
import { createPalette } from "./createPalette";
import { createProps } from "./createProps";
import { createSpacing } from "./createSpacing";
import { createTheme } from "@material-ui/core/styles";
import { createTypography } from "./createTypography";
export var createEpicTheme = function (_a) {
    if (_a === void 0) { _a = {}; }
    var overrides = _a.overrides, options = __rest(_a, ["overrides"]);
    var palette = createPalette(options.palette);
    var breakpoints = createBreakpoints(options.breakpoints);
    var typography = createTypography(typeof options.typography === "function"
        ? options.typography(palette)
        : options.typography);
    var theme = createTheme(__assign(__assign({}, options), { palette: palette, breakpoints: breakpoints, typography: typography, spacing: createSpacing(options.spacing), props: createProps(options.props) }));
    theme.overrides = createOverrides(theme, overrides);
    return theme;
};
//# sourceMappingURL=createEpicTheme.js.map